<template>
  <div>
    <div class="subtitle1 mb-1">
      {{ $t("modals.exportDevices.subtitle") }}
    </div>
    <v-radio-group v-model="localValue.type" hide-details>
      <v-radio
        v-for="choice in [ExportChoice.ALL, ExportChoice.SPECIFIC]"
        :key="choice"
        class="mb-3"
        :value="choice"
        :ripple="false"
        :label="$t(`modals.exportDevices.choices.${choice}`)"
      ></v-radio>
    </v-radio-group>
    <export-devices-filters
      v-model="localValue.filters"
      :labels="devicesSettingsStore.labels"
      :statuses="devicesStore.statuses"
      :raw-os-versions="osVersionsFromStore"
      :raw-client-versions="clientVersionsFromStore"
      :disabled="localValue.type === ExportChoice.ALL"
      class="mt-2"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, type PropType, ref, watch } from "vue";
import { type ExportDialogPayload } from "@/_store/exports.module";
import { defaultFiltersState, type DevicesFilters } from "@/_store/filters.module";
import type { DialogDataConfig } from "@/_store/dialogs.module";
import { useDevicesStore } from "@/_store/devices.module";
import { useDevicesSettingsStore } from "@/_store/devices-settings.module";
import { storeToRefs } from "pinia";
import { ExportChoice } from "@/constants/exports.ts";
import ExportDevicesFilters from "@/components/devices/ExportDevicesFilters.vue";

export default defineComponent({
  components: { ExportDevicesFilters },
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  setup(_, { emit }) {
    const devicesStore = useDevicesStore();
    const devicesSettingsStore = useDevicesSettingsStore();
    const { osVersions: osVersionsFromStore, clientVersions: clientVersionsFromStore } =
      storeToRefs(devicesStore);

    const localValue = ref<ExportDialogPayload<DevicesFilters>>({
      type: ExportChoice.ALL,
      filters: {
        ...defaultFiltersState.devicesFilters,
      },
    });

    onMounted(async () => {
      await devicesStore.init();
    });

    watch(
      localValue,
      (newVal) => {
        emit("update:localValue", newVal);
      },
      { deep: true, immediate: true }
    );

    return {
      localValue,
      ExportChoice,
      devicesStore,
      devicesSettingsStore,
      osVersionsFromStore,
      clientVersionsFromStore,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(.clear-btn) {
  display: none !important;
}
</style>
